import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {Message} from 'coaz-ui';
import SubmitButton from './SubmitButton';
import client from '../client'

const ChangePassword = () => {
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState(""); 
    const [confirmPassword, setConfirmPassword] = useState(""); 
    const [loading,setLoading] = useState(true);
    const [message,setMessage] = useState({content:'',success:false}); 
    const {request,errorMessage} = client;

    const params = new URLSearchParams(window.location.search);
    
    const navigate = useNavigate();

    const submit = async (e) => {
        setMessage({content:'',success:false});
        if(params && params.get('username') && newPassword === confirmPassword) {
            setLoading(true);
            await request('PUT','users/set-password/otp',null,{
                username:params.get('username'),
                currentPassword:otp,
                newPassword:newPassword
            },false)
            .then((response) => {
                if(response == true) {
                    navigate("/_login")
                } else {
                    setMessage({content:errorMessage(response),success:false});
                    setLoading(false);
                }
            })
            .catch((error) => {
                setMessage({content:errorMessage(error),success:false});
                setLoading(false);
            });
        } else {
            setMessage({content:"New password and confirm password didn't match, try again!",success:false});
        }
    };

    useEffect(() => {
        setLoading(false);
    })

    return (
    <div className='flex items-center justify-center w-full h-full overflow-hidden'>
        <div onKeyDown={(e) => {
                if (e.key === "Enter") {
                    submit(e);
                }
            }}  
            style={{backdropFilter:'blur(20px)'}} 
            className='flex flex-col w-[640px] items-center rounded-2xl bg-[rgba(255,255,255,.5)] shadow-2xl'>
            <img src='/logo.png' className='w-32 h-32 m-4'/>
            <div className='flex flex-row space-x-2 text-2xl'>
                <p className='font-bold text-[rgb(0,175,240)]'>RESET</p>
                <p className='font-light'>PASSWORD</p></div>
            <div className='flex flex-col p-4 space-y-4 w-96'>
                <input 
                    type="text" 
                    name="username"
                    value={params && params.get('username')?params.get('username'):''}
                    disabled={true}
                    className='flex w-full h-10 p-2 mb-4 text-sm font-thin rounded-lg shadow-md shrink-0 focus:outline-none whitespace-nowrap'
                />
                <input 
                    type="password" 
                    name="otp"
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                    placeholder='Otp...'
                    className='flex w-full h-10 p-2 text-sm font-thin rounded-lg shadow-md shrink-0 focus:outline-none whitespace-nowrap'
                />
                <input 
                    type="password" 
                    name="newPassword"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    placeholder='New password...'
                    className='flex w-full h-10 p-2 text-sm font-thin rounded-lg shadow-md shrink-0 focus:outline-none whitespace-nowrap'
                />
                <input 
                    type="password" 
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    placeholder='Confirm password...'
                    className='flex w-full h-10 p-2 text-sm font-thin rounded-lg shadow-md shrink-0 focus:outline-none whitespace-nowrap'
                />
                <SubmitButton name='Sign in' onSubmit={submit} loading={loading}/>
                <Message message={message}/>
            </div>
        </div>
    </div>
    )
}

export default ChangePassword
